export const TYPE_AHEAD_CONSTANTS = {
    defaultValues: {
        debounceTime: 500,
        minLength: 0,
        placeholder: 'Placeholder',
        closeListTime: 200
    },
    regex: /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g
};
